<div class="p-dialog-header px-0">
  <div class="p-dialog-title">
    <div class="flex gap-spacing-xs align-items-center">
      @if (!isClient) {
        <span class="title-small-bold text-primary-color">Activity Log Details for Ride #{{ rideId }} - Waypoint #{{ order }}</span>
      } @else {
        <span class="title-small-bold text-primary-color">Activity Log Details for Waypoint #{{ order }}</span>
      }
    </div>
  </div>
  <div class="p-dialog-header-icons">
    <app-button (btnClick)="ref.close()" [iconOnlyButton]="true" icon="icon-x" sizeClass="p-button-sm" severity="secondary"
      [textButton]="true"></app-button>
  </div>
</div>
@if (activityLogTableData.data!.length > 0) {
<div class="table-section">
  <app-basic-table [tableData]="activityLogTableData" [showIndex]="true"></app-basic-table>
</div>
} @else {
  <app-no-records minHeight=""></app-no-records>
}

<div class="p-dialog-footer footer pt-spacing-3xl px-0">
  <app-button label="Close" (btnClick)="ref.close()" sizeClass="p-button-md" severity="secondary"></app-button>
</div>